module.exports = __webpack_public_path__ + "img/icon_nav5_active.c6a813d0.3e86835f.svg";